import { keepPreviousData, queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';

import z from 'zod';
import { Membership, MembershipStatus } from '@/types/api/membership';

export const ListMembershipsParamsSchema = z
  .object({
    status: z.array(z.nativeEnum(MembershipStatus)),
    groupId: z.string().nonempty(),
    userId: z.string().nonempty(),
    include: z.array(z.enum(['group', 'user'])),
  })
  .partial();

export type ListMembershipsParams = z.infer<typeof ListMembershipsParamsSchema>;

export const listMemberships = async (params: ListMembershipsParams): Promise<Membership[]> => {
  return (await api.get(`/memberships`, { params })).data;
};

export const listMembershipsQueryOptions = (params: ListMembershipsParams = {}) => {
  return queryOptions({
    queryKey: Object.values(params).filter(Boolean).length ? ['memberships', params] : ['memberships'],
    queryFn: () => listMemberships(params),
    enabled: Boolean(params),
    placeholderData: keepPreviousData,
  });
};

type UseMembershipsOptions = {
  params?: ListMembershipsParams;
  queryConfig?: QueryConfig<typeof listMembershipsQueryOptions>;
};

export const useMemberships = ({ queryConfig, params }: UseMembershipsOptions) => {
  return useQuery({
    ...listMembershipsQueryOptions(params),
    ...queryConfig,
  });
};

export const useMembershipsSuspense = ({ queryConfig, params }: UseMembershipsOptions) => {
  return useSuspenseQuery({
    ...listMembershipsQueryOptions(params),
    ...queryConfig,
  });
};
